import { render, staticRenderFns } from "./ListResources.vue?vue&type=template&id=daa0b806&scoped=true&"
import script from "./ListResources.vue?vue&type=script&lang=js&"
export * from "./ListResources.vue?vue&type=script&lang=js&"
import style0 from "./ListResources.vue?vue&type=style&index=0&id=daa0b806&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa0b806",
  null
  
)

export default component.exports